<template>
    <el-dialog
        :title="(isForm ? (authId ? '编辑' : '添加菜单') : '查看') + dialogTitle"
        width="750px"
        :model-value="modelValue"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form ref="formRef" :model="formData" :rules="isForm ? formRules : {}" label-width="110px" style="max-width: 690px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="上级菜单" prop="parent">
                        <el-tree-select
                            v-show="isForm"
                            v-model="formData.parent"
                            :data="authOptionLists"
                            check-strictly
                            :render-after-expand="false"
                            value-key="name"
                            node-key="id"
                            placeholder="请选择"
                            :default-expanded-keys="['']"
                            style="width: 100%"
                            :props="{ label: 'name' }"
                        >
                            <template #default="{ data }">
                                {{ data.name }}
                                <span v-if="data.children" style="color: gray">({{ data.children.length }})</span>
                            </template>
                        </el-tree-select>
                        <span v-show="!isForm">{{ parentName }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="菜单类型" prop="auth_type">
                        <el-radio-group v-if="isForm" v-model="formData.auth_type">
                            <el-radio v-for="item in authType" :key="item.label" :value="item.value">{{ item.label }}</el-radio>
                        </el-radio-group>
                        <span v-else>{{ authTypeJson[formData.auth_type] }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formData.auth_type !== 3">
                    <el-form-item label="菜单图标" prop="icon">
                        <el-select v-if="isForm" v-model="formData.icon" placeholder="Select" style="width: 240px">
                            <template #prefix>
                                <component v-if="formData.icon && !formData.icon.includes('#')" :is="formData.icon"></component>
                            </template>
                            <div class="icon-option-list">
                                <el-option v-for="icon in $icons" :key="icon" :value="icon" class="icon-option-item">
                                    <component
                                        :class="[icon, 'icon', { 'icon-active': icon == formData.icon }]"
                                        :is="icon"
                                        @click="handleIconClick(icon)"
                                    ></component>
                                </el-option>
                            </div>
                        </el-select>
                        <template v-else>
                            <component style="width: 15px; height: 15px" :is="formData.icon"></component>
                        </template>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="菜单名称" prop="name">
                        <el-input v-if="isForm" v-model="formData.name" placeholder="请输入菜单名称"></el-input>
                        <span v-else>{{ formData.name }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="显示排序" prop="list_order">
                        <el-input-number
                            v-if="isForm"
                            v-model="formData.list_order"
                            class="mx-4"
                            :min="0"
                            :max="999999"
                            controls-position="right"
                        />
                        <span v-else>{{ formData.list_order }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formData.auth_type !== 3">
                    <el-form-item prop="ext_link">
                        <template #label>
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="选择是外链则路由地址需要以`http(s)://`开头"
                                placement="top"
                            >
                                <el-icon v-if="isForm">
                                    <QuestionFilled />
                                </el-icon>
                            </el-tooltip>
                            <span>是否外链</span>
                        </template>
                        <el-radio-group v-if="isForm" v-model="formData.ext_link">
                            <el-radio v-for="item in extLink" :key="item.label" :value="item.value">{{ item.label }}</el-radio>
                        </el-radio-group>
                        <span v-else>{{ formData.ext_link == 1 ? '是' : '否' }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formData.auth_type !== 3">
                    <el-form-item prop="path">
                        <template #label>
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头"
                                placement="top"
                            >
                                <el-icon v-if="isForm">
                                    <QuestionFilled />
                                </el-icon>
                            </el-tooltip>
                            <span>路由地址</span>
                        </template>
                        <el-input v-if="isForm" v-model="formData.path" placeholder="请输入路由地址"></el-input>
                        <span v-else>{{ formData.path }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formData.auth_type == 2">
                    <el-form-item>
                        <template #label>
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="访问的组件路径，如：`system/user/index`，默认在`views`目录下"
                                placement="top"
                            >
                                <el-icon v-if="isForm">
                                    <QuestionFilled />
                                </el-icon>
                            </el-tooltip>
                            <span>组件路径</span>
                        </template>
                        <el-input v-if="isForm" v-model="formData.component" placeholder="请输入组件路径"></el-input>
                        <span v-else>{{ formData.component }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="perms">
                        <template #label>
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasPermi('system:user:list')`)"
                                placement="top"
                            >
                                <el-icon v-if="isForm">
                                    <QuestionFilled />
                                </el-icon>
                            </el-tooltip>
                            <span>权限字符</span>
                        </template>
                        <el-input v-if="isForm" v-model="formData.perms" placeholder="请输入权限字符"></el-input>
                        <span v-else>{{ formData.perms }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formData.auth_type == 2">
                    <el-form-item>
                        <template #label>
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content='访问路由的默认传递参数，如：`{"id": 1, "name": "ry"}`'
                                placement="top"
                            >
                                <el-icon v-if="isForm">
                                    <QuestionFilled />
                                </el-icon>
                            </el-tooltip>
                            <span>路由参数</span>
                        </template>
                        <el-input v-if="isForm" v-model="formData.query" placeholder="请输入路由参数"></el-input>
                        <span v-else>{{ formData.query || '-' }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="formData.auth_type == 2">
                    <el-form-item>
                        <template #label>
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="选择是则会被`keep-alive`缓存，需要匹配组件的`name`和地址保持一致"
                                placement="top"
                            >
                                <el-icon v-if="isForm">
                                    <QuestionFilled />
                                </el-icon>
                            </el-tooltip>
                            <span>是否缓存</span>
                        </template>
                        <el-radio-group v-if="isForm" v-model="formData.is_cache">
                            <el-radio v-for="item in cacheOptions" :key="item.label" :value="item.value">
                                {{ item.label }}
                            </el-radio>
                        </el-radio-group>
                        <span v-else>{{ cacheObj[formData.is_cache]?.label }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="visible" v-if="formData.auth_type !== 3">
                        <template #label>
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="选择隐藏则路由将不会出现在侧边栏，但仍然可以访问"
                                placement="top"
                            >
                                <el-icon v-if="isForm">
                                    <QuestionFilled />
                                </el-icon>
                            </el-tooltip>
                            <span>显示状态</span>
                        </template>
                        <el-radio-group v-if="isForm" v-model="formData.visible">
                            <el-radio :value="1">显示</el-radio>
                            <el-radio :value="0">隐藏</el-radio>
                        </el-radio-group>
                        <span v-else>{{ formData.visible == 1 ? '显示' : '隐藏' }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item v-if="formData.auth_type !== 3">
                        <template #label>
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="选择停用则路由将不会出现在侧边栏，也不能被访问"
                                placement="top"
                            >
                                <el-icon v-if="isForm">
                                    <QuestionFilled />
                                </el-icon>
                            </el-tooltip>
                            <span>菜单状态</span>
                        </template>
                        <el-radio-group v-if="isForm" v-model="formData.status">
                            <el-radio v-for="item in statusOptions" :key="item.label" :value="item.value">
                                {{ item.label }}
                            </el-radio>
                        </el-radio-group>
                        <span v-else>{{ formData.status == 1 ? '正常' : '停用' }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="备注">
                <el-input v-if="isForm" v-model="formData.remark" type="textarea" placeholder="请输入备注"></el-input>
                <div v-else>{{ formData.remark || '-' }}</div>
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref, watch } from 'vue'
import { addAuth, getAuthDetail, putAuth } from '@/api/auth'
import { ElMessage } from 'element-plus'
import { getDataCodeOptions } from '@/utils/common'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    authId: {
        type: String,
        required: false
    },
    parentId: {
        type: String,
        required: false
    },
    modId: {
        type: String,
        required: false
    },
    authOptionLists: {
        type: Array,
        default: () => []
    },
    moduleOptionLists: {
        type: Array,
        default: () => []
    },
    module: {
        type: String,
        required: true
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])
// 表单源
const formData = ref({
    module: '',
    parent: '',
    auth_type: 2,
    icon: '',
    name: '',
    list_order: 1,
    ext_link: 0,
    path: '',
    component: '',
    perms: '',
    query: '',
    is_cache: 1,
    visible: 1,
    status: 1,
    remark: ''
})

const dialogTitle = ref('')
const authTypeJson = {
    1: '目录',
    2: '菜单',
    3: '按钮'
}

// 菜单图标
function handleIconClick(icon) {
    formData.value.icon = icon
}

// 验证规则

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请填写菜单名称'
        }
    ],
    list_order: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入显示排序'
        }
    ],
    path: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入路由地址'
        }
        // { pattern: /^[a-zA-Z0-9-_]+$/, message: '路径格式不正确' }
    ],
    perms: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入权限字符'
        }
    ]
})

const submitLoading = ref(false)
const formRef = ref(null)
// 关闭
const closed = () => {
    dialogTitle.value = ''
    emits('update:modelValue', false)
    formRef.value.resetFields()
}

// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    if (props.authId !== '') {
        await doPutAuth()
    } else {
        await doAddAuth()
    }
    // router.go(0)
}

// 修改模块
const doPutAuth = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        formData.value.id = props.authId
        await putAuth(formData.value)
            .then(() => {
                // 模块修改成功
                emits('updateForm')
                ElMessage.success('修改成功！')
                closed()
                submitLoading.value = false
            })
            .catch(() => {
                submitLoading.value = false
            })
    })
}

// 添加
const doAddAuth = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        await addAuth(formData.value)
            .then(() => {
                // 模块添加成功
                emits('updateForm')
                ElMessage.success('添加成功！')
                closed()
                submitLoading.value = false
            })
            .catch(() => {
                submitLoading.value = false
            })
    })
}
const fn = (source) => {
    const res = []
    source.forEach((el) => {
        res.push(el)
        el.children && res.push(...fn(el.children))
    })
    return res
}
// 获取详情
const parentName = ref('主类目')
const getAuthDetailFun = async () => {
    const data = await getAuthDetail(props.authId)
    if (data.parent === null) {
        data.parent = ''
    }
    formData.value = { ...data }
    if (formData.value.parent) {
        parentName.value = fn(props.authOptionLists).find((ele) => ele.id === formData.value.parent)?.name
    }
}

const authType = ref([])
const statusOptions = ref([])
const cacheOptions = ref([])
const cacheObj = ref([])
const extLink = ref([])
onMounted(async () => {
    const { list } = await getDataCodeOptions('auth_auth_type')
    authType.value = list.map((ele) => {
        return {
            ...ele,
            value: Number(ele.value)
        }
    })
    const { list: status } = await getDataCodeOptions('common_status')
    statusOptions.value = status.map((ele) => {
        return {
            ...ele,
            value: Number(ele.value)
        }
    })
    const { list: cache, jsonData } = await getDataCodeOptions('auth_is_cache')
    cacheOptions.value = cache.map((ele) => {
        return {
            ...ele,
            value: Number(ele.value)
        }
    })
    cacheObj.value = jsonData
    const { list: link } = await getDataCodeOptions('auth_ext_link')
    extLink.value = link.map((ele) => {
        return {
            ...ele,
            value: Number(ele.value)
        }
    })
})

watch(
    () => props.authId,
    (newVal) => {
        if (newVal && props.authId) {
            getAuthDetailFun()
        } else {
            formData.value = {
                id: '',
                module: '',
                parent: '',
                auth_type: 2,
                icon: '',
                name: '',
                list_order: 1,
                ext_link: 0,
                path: '',
                component: '',
                perms: '',
                query: '',
                is_cache: 1,
                visible: 1,
                status: 1,
                remark: ''
            }
        }
    }
)
watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal) {
            formData.value.module = props.module
            if (props.parentId) {
                formData.value.parent = props.parentId
            }
        }
    }
)
</script>

<style lang="scss" scoped>
.el-icon {
    margin-top: 8px;
}

.icon-option-list {
    width: 300px;
    height: 200px;
    overflow-y: scroll;
    display: flex;
    flex-wrap: wrap;
}
.icon-option-list .icon-option-item {
    padding: 5px 10px;
    height: unset;
    line-height: unset;
}
.icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    color: var(--el-text-color-regular);
    font-size: 20px;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    line-height: 45px;
    margin: 5px;
}

.icon:hover {
    color: var(--el-color-primary);
}

.icon-active {
    color: var(--el-color-primary);
}

:deep(svg.icon-active) {
    fill: var(--el-color-primary);
}
</style>
